// extracted by mini-css-extract-plugin
export default {"button":"Qk-z","reviewSort":"Rk-z"};